const SCROLL_CONFIG = {
  DELAY_MS: 200,
  DEBOUNCE_MS: 50,
  THROTTLE_MS: 16, // ~60fps
  NEW_LINE_OFFSET: 60,
  NEAR_BOTTOM_THRESHOLD: 50,
  SCROLL_VERIFICATION_THRESHOLD: 10,
  MAX_VERIFICATION_ATTEMPTS: 2,
  FOOTER_ADJUSTMENT_THRESHOLD: 5,
  UNREAD_VISIBILITY_THRESHOLD: 100,
} as const;

const TIMING_CONFIG = {
  INFINITE_SCROLL_BUFFER: 350, // 300ms blockDuration + 50ms buffer
  SAFETY_TIMEOUT: 10000,
  BATCH_DELAY: 100,
  SEND_SCROLL_DELAY_MULTIPLE: 25,
  SEND_SCROLL_DELAY_SINGLE: 50,
  INFINITE_SCROLL_DOWN_RESET: 1000,
  SCROLL_RESET_DELAY: 50,
  VISIBILITY_RESET_DELAY: 100,
  DRAG_RESET_DELAY: 100,
  UNREAD_LINE_RESET_DELAY: 300,
  SCROLL_RESTORATION_DELAY: 0,
  SMOOTH_SCROLL_DURATION: 0,
} as const;

const LINK_PREVIEW_CONFIG = {
  MAX_CONCURRENT_REQUESTS: 3,
  BATCH_DELAY_MS: 100,
} as const;

export { LINK_PREVIEW_CONFIG, SCROLL_CONFIG, TIMING_CONFIG };
